import { InputSelect } from "#common/componentes/Inputs"
import { SkeletonSquareGrid } from "#common/Skeleton"
import { TextGrid } from "#common/Texto"
import InputAutocompleteAreas from "#core/inputs/autocomplete/InputAutocompleteAreas"
import { useApi } from "#hooks/useApi"
import SelectCategory from "#training/components/SelectCategory"
import { useAnnualPlanContext } from "#training/contexts/contexts"
import { annualPlanAreasGet } from "#training/services/Api"
import { Box, Paper, Stack } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { useEffect, useMemo, useState } from "react"

const PlanningFilter = () => {
	const { category, setSelectCategory, filterCourses, setFilter } =
		useAnnualPlanContext()
	const [departamentos, setDepartamentos] = useState("")

	const { data, loading } = useApi(annualPlanAreasGet, { autoFetch: true })
	const list_years = useMemo(() => {
		const years = []
		for (let index = 2023; index <= new Date().getFullYear() + 1; index++) {
			years.push({ año: index })
		}
		return years
	}, [])

	useEffect(() => {
		if (data?.areas?.length) setFilter("area", data?.areas[0].id)
		if (list_years?.length) setFilter("year", new Date().getFullYear())
	}, [data?.areas, list_years?.length, setFilter])

	const departamentoValue = useMemo(() => {
		if (!departamentos) return null
		return departamentos?.find((area) => area.id === filterCourses?.area)
	}, [departamentos, filterCourses?.area])
	if (loading) return <SkeletonSquareGrid height={"80vh"} />

	if (!data?.areas?.length)
		return (
			<Grid container spacing={2}>
				<TextGrid
					allSize={12}
					label="No Tienes departamentos etSelectedAreas cargo"
				/>
			</Grid>
		)

	return (
		<Box component={Paper} sx={{ p: 2, borderRadius: 2 }}>
			<Stack direction={"row"} spacing={2} justifyContent={"center"}>
				<SelectCategory
					data={category}
					value={filterCourses?.category}
					getData={(data) => {
						setFilter("category", data[0]?.id)
						setSelectCategory(data[0])
					}}
					setValue={(category) => {
						setFilter("category", category)
					}}
					onChange={setSelectCategory}
					minWidth={"25vw"}
				/>
				<InputAutocompleteAreas
					value={departamentoValue}
					setValue={(value) => {
						setFilter("area", value?.id || "")
					}}
					getData={(data) => {
						setFilter("area", data?.areas[0]?.id || "")
						setDepartamentos(data?.areas || [])
					}}
					fullWidth={false}
					minWidth={"25vw"}
				/>
				<InputSelect
					dataLabel="año"
					dataID="año"
					sizeAll={4}
					label="Año"
					data={list_years}
					option={filterCourses?.year}
					setOption={(value) => setFilter("year", value)}
				/>
			</Stack>
		</Box>
	)
}
export default PlanningFilter
